/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'goal-fields.goal-followers.add-followers-title': 'Ajouter des abonnés',
  'goal-fields.goal-followers.title': 'Abonnés',
  'goal-fields.goal-links.add-parent-goal-title': 'Ajouter un objectif parent',
  'goal-fields.goal-links.edit-parent-goal-title': 'Modifier un objectif parent',
  'goal-fields.goal-links.unlink-parent-goal-title': "Dissocier l'objectif parent",
  'goal-fields.goal-metrics.automatic-metric-title': 'À partir des sous-objectifs',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': 'Supprimer',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': 'Paramètres',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': 'Afficher plus',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': 'Mettre à jour la valeur',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Début :',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Cible :',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    "L'avancement est renseigné automatiquement via {compass}. Cette métrique d'objectif ne peut être modifiée que dans {compass}.",
  'goal-fields.goal-metrics.no-metrics-instructions': "Accédez à la page complète de l'objectif pour modifier ce champ",
  'goal-fields.goal-metrics.no-metrics-title': 'Aucune métrique',
  'goal-fields.goal-metrics.open-in-new-window-label': 'Ouvrir dans une nouvelle fenêtre',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': "d'avancement",
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'Aucun sous-objectif avec métriques lié',
  'goal-fields.goal-metrics.title': 'Avancement',
  'goal-fields.goal-owner.title': 'Propriétaire',
  'goal-fields.goal-start-date.add-start-date-title': 'Ajouter une date de début',
  'goal-fields.goal-start-date.cancel-button': 'Enregistrer',
  'goal-fields.goal-start-date.creation-date': 'Cet objectif a été créé le {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': "Modifier la date de début de l'objectif",
  'goal-fields.goal-start-date.enter-start-date-title': 'Saisissez une date de début',
  'goal-fields.goal-start-date.open-calendar-label': 'Ouvrir le calendrier',
  'goal-fields.goal-start-date.title': 'Date de début',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'En cours',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': "Plus d'états",
  'goal-fields.goal-status-picker.goal-status-okr-current-status': "Quel est l'état actuel ?",
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    'Vous adoptez les Objectifs et résultats clés (OKR) ? <link>Découvrez comment utiliser les objectifs pour les OKR</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': "Lien d'aide",
  'goal-fields.goal-status.archived': 'Archivés',
  'goal-fields.goal-status.at-risk': 'À risque',
  'goal-fields.goal-status.cancelled': 'Annulé',
  'goal-fields.goal-status.completed': 'Terminé(s) 🎉',
  'goal-fields.goal-status.off-track': 'Compromis',
  'goal-fields.goal-status.on-track': 'Sur la bonne voie',
  'goal-fields.goal-status.paused': 'Interrompu(s)',
  'goal-fields.goal-status.pending': 'En attente',
  'goal-fields.goal-status.title': 'État',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Ajouter des sous-objectifs',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Dissocier le sous-objectif',
  'goal-fields.goal-tags.add-tags-title': 'Ajouter des tags',
  'goal-fields.goal-tags.title': 'Tags',
  'goal-fields.goal-target-date.picker-placeholder': 'En attente',
  'goal-fields.goal-target-date.title': 'Date cible',
  'goal-fields.goal-type.goal': 'Objectif',
  'goal-fields.goal-type.key-result': 'Résultat clé',
  'goal-fields.goal-type.objective': 'Objectif OKR',
  'goal-fields.goal-type.title': 'Type',
  'goal-fields.parent-goal.title': 'Objectif parent',
  'goal-fields.sub-goals.title': 'Sous-objectifs',
  'goal-fields.teams.add-teams-title': 'Ajouter des équipes',
  'goal-fields.teams.follow-team': 'Suivre une équipe',
  'goal-fields.teams.remove-team': "Supprimer l'équipe",
  'goal-fields.teams.search-team-placeholder': 'Rechercher une équipe',
  'goal-fields.teams.show-more': 'Afficher plus',
  'goal-fields.teams.title': 'Équipes',
  'goal-fields.teams.verified-team-label': 'Équipe vérifiée',
  'goal-fields.teams.view-profile': 'Afficher le profil',
  'goal-fields.use-goal-flags.generic-error-description':
    "Une erreur s'est produite. Veuillez réessayer dans quelques minutes.",
  'goal-fields.use-goal-flags.generic-error-title': 'Une erreur est survenue',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': "Impossible de modifier le propriétaire de l'objectif",
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': "Impossible d'ajouter la rubrique",
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'Impossible de créer le thème',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    "Le nom d'étiquette que vous avez saisi est trop long. Veuillez saisir un nom d'étiquette d'au maximum 255 caractères.",
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': "Impossible de créer l'étiquette",
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'Impossible de supprimer la rubrique',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title':
    "Une erreur s'est produite lors de l'ajout de l'équipe, veuillez réessayer",
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title':
    "Une erreur s'est produite lors de la suppression de l'équipe, veuillez réessayer",
  'goal-fields.use-goal-flags.parent-goal-change-error-header': "Impossible de modifier l'objectif parent",
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Impossible de modifier la date de début',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Impossible de modifier la date cible',
  'townsquare.goal-fields.tag': 'Supprimer le tag',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {Utilisé à {usageCount,number} endroit} other {Utilisé à {usageCount,number} endroits}}',
};
